// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const { ContentBox } = require('commonsComponents/contentBox');

class MyWalletImportsTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            tableClassName,
            firstValue,
            firstLabel,
            operationSymbol,
            secondValue,
            secondLabel,
            secondValueClassName,
            totalValue,
            totalLabel
        } = this.props;

        return (
            <ContentBox hasShadow={false} customClassName={tableClassName}>
                <div className="broker-calculate-my-wallet-modal__rentability-first-line">
                    <span className="broker-calculate-my-wallet-modal__two-lines-value">
                        {firstValue}
                    </span>
                    <span className="broker-calculate-my-wallet-modal__label">
                        {firstLabel}
                    </span>
                </div>
                <div className="broker-calculate-my-wallet-modal__operation-symbol">
                    {operationSymbol}
                </div>
                <div className="broker-calculate-my-wallet-modal__rentability-second-line">
                    <span className={secondValueClassName}>
                        {secondValue}
                    </span>
                    <span className="broker-calculate-my-wallet-modal__label">
                        {secondLabel}
                    </span>
                </div>
                <div className="broker-calculate-my-wallet-modal__second-table">
                    <span className="broker-calculate-my-wallet-modal__one-line-value">
                        {totalValue}
                    </span>
                    <div>
                        {totalLabel}
                    </div>
                </div>
            </ContentBox>
        );
    }
}

MyWalletImportsTable.propTypes = {
    tableClassName: PropTypes.string.isRequired,
    firstValue: PropTypes.string.isRequired,
    firstLabel: PropTypes.object.isRequired,
    operationSymbol: PropTypes.object.isRequired,
    secondValue: PropTypes.string.isRequired,
    secondLabel: PropTypes.object.isRequired,
    secondValueClassName: PropTypes.string.isRequired,
    totalValue: PropTypes.string.isRequired,
    totalLabel: PropTypes.object.isRequired
};

module.exports = MyWalletImportsTable;
